import { MANUAL_EVALUATION, AUTOMATIC_EVALUATION } from 'Constants/General';
import {
  ModuleList,
  LessonList,
  IsUserSubscribed,
  UserEvaluationCreate,
  UserEvaluationUpdate,
  UserEvaluationPublish,
  UserEvaluationListByUserId,
  UserRemaningByLesson,
} from './Request';
import UserListUsersByCourse from './Request/User_listUsersByCourse';
import graphql from './graphql';

export const lessonList = async ({ moduleId }) => LessonList({ moduleId });

export const moduleList = async ({ courseId, userId }) => {
  const modulesFetch = await ModuleList({ courseId });
  const modules = modulesFetch?.filter(module => module.isDraft !== true);
  const lessonListPromise = [];
  const filteredEvaluations = [];

  for (let x = 0; x < modules.length; x += 1) {
    lessonListPromise.push(LessonList({ moduleId: modules[x].id }));
  }

  // Para todos los modulos de este curso, se obtienen las lecciones.
  const courseModules = (await Promise.all(lessonListPromise)) || [];

  const userRemainingLessonsPromise = [];

  for (let x = 0; x < courseModules?.length; x += 1) {
    const currentModule = courseModules[x];

    for (let y = 0; y < currentModule.length; y += 1) {
      const currentLesson = currentModule[y];
      const currentLessonType = currentLesson.LessonType.name;

      if (currentLessonType === AUTOMATIC_EVALUATION) {
        userRemainingLessonsPromise.push(
          UserRemaningByLesson({
            courseId,
            lessonId: currentLesson.id,
          }).then(remaining => ({
            remaining,
            lessonId: currentLesson.id,
          }))
        );
      }

      if (currentLessonType === MANUAL_EVALUATION || currentLessonType === AUTOMATIC_EVALUATION) {
        filteredEvaluations.push(currentLesson);
      }
    }
  }

  // Se obtienen las lecciones restantes del usuario esperando la respuesta de todas.
  const userRemainingLessons = await Promise.all(userRemainingLessonsPromise);

  // Para cada lección en la lista de lecciones filtradas, se busca la cantidad restante de lecciones del usuario.
  for (let x = 0; x < courseModules.length; x += 1) {
    const currentLesson = courseModules[x];

    if (userRemainingLessons.length < 0) break;

    for (let y = 0; y < userRemainingLessons.length; y += 1) {
      if (userRemainingLessons[y].lessonId === currentLesson.id) {
        currentLesson.count = userRemainingLessons[y].remaining;
      }
    }
  }

  const response = await UserEvaluationListByUserId({
    userId,
    lessonIds: filteredEvaluations.map(evaluation => evaluation.id),
  });

  const finalEvaluations = filteredEvaluations.map(evaluation => {
    response.forEach(userEvaluation => {
      if (userEvaluation.lessonId === evaluation.id && userEvaluation.isDraft !== true) {
        evaluation.grade = userEvaluation.grade;
      }
    });

    return evaluation;
  });

  return finalEvaluations;
};

export const isUserSubscribed = async ({ courseId, userId }) => IsUserSubscribed({ courseId, userId });

export const userEvaluationUserList = async ({ courseId, lessonId }) => {
  const promises = [];
  promises.push(UserListUsersByCourse({ courseId, lessonId }));
  promises.push(graphql('Department_list', 'name', 'query'));
  promises.push(graphql('Terminal_list', 'name', 'query'));
  promises.push(graphql('JobTitle_list', 'name', 'query'));

  const response = await Promise.all(promises);

  const fetchedUsers = response[0];
  const users = [];

  let index = 0;

  fetchedUsers.forEach(data => {
    const user = data.User;
    users.push([
      user.fullName,
      user.JobTitle.name,
      user.Department.name,
      user.Terminal.name,
      user.UserEvaluations.grade,
      user?.UserLessons?.attended || false,
      user.id,
      user?.UserEvaluations?.id,
      index,
      user?.UserEvaluations?.isDraft,
      user.UserEvaluations.grade !== null,
    ]);
    index += 1;
  });

  const mapDeparment = data => data.map(department => department.name);
  const departments = mapDeparment(response[1].Department_list);

  const mapTerminal = data => data.map(terminal => terminal.name);
  const terminals = mapTerminal(response[2].Terminal_list);

  const mapJobTitle = data => data.map(jobTitle => jobTitle.name);
  const jobTitles = mapJobTitle(response[3].JobTitle_list);

  return { users, departments, terminals, jobTitles };
};

export const userEvaluationCreate = async ({ userId, lessonId, grade, isDraft }) => {
  const response = await UserEvaluationCreate({
    userId,
    lessonId,
    grade,
    isDraft,
  });

  return response;
};

export const userEvaluationUpdate = async ({ id, grade, isDraft }) => {
  const response = await UserEvaluationUpdate({
    id,
    grade,
    isDraft,
  });

  return response;
};

export const userEvaluationPublish = async ({ lessonId }) => {
  const response = await UserEvaluationPublish({ lessonId });
  return response;
};

export default {
  moduleList,
  IsUserSubscribed,
  userEvaluationUserList,
  userEvaluationCreate,
  userEvaluationUpdate,
};
